<template>
  <div class="main">
    <report-top> </report-top>
<selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="chaxun" class="chaxun">查询</Button
        ></template
      ></selectTool
    >
    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(220)"
    >
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      columns: [
        {
          type: "index",
          align: "center",
        },
        {
          title: "标题",
          key: "title",
        },
        {
          title: "内容",
          key: "content",
        },
        {
          title: "发布时间",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.noticeTime));
          },
        },
      ],
      tableData: [],
      total: 0,
      searchItem: {
        deviceIdList: [],
        driverIdList: [],
        endTime: 0,
        startTime: 0,
        pageSize: 50,
        pageNumber: 1,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.msg + "/notice/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          this.tableData = data;
        }
      });
    },
    exportAll() {
      var params = [
        {
          name: "deviceIdList",
          value: this.deviceIdList,
        },
        {
          name: "startTime",
          value: this.timeObj.start,
        },
        {
          name: "endTime",
          value: this.timeObj.end,
        },
      ];
      this.utils.exportData(axios.report + "/countDaily/export", params);
    },
    reCarLists(x) {
      this.deviceIdList = [];
      for (const i in x) {
        this.deviceIdList.push(x[i].deviceId);
      }
      this.getList();
    },
    reDriverList(v) {
      this.driverIdList = [];
      for (const i in v) {
        this.driverIdList.push(v[i].driverId);
      }
      this.getList();
    },

    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },

  },
  mounted() {
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.chaxun();
    }, 300);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// ../common/src/components/alarm/notice.vue